<template>
  <div
    class="logo-container"
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 33 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8" width="17" height="8.11268" rx="4" fill="currentColor" />
      <rect
        x="25"
        y="9.12676"
        width="8"
        height="17.7465"
        rx="4"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.7633 36H20.9998C23.209 36 24.9998 34.2091 24.9998 32V31.8873C24.9998 29.6782 23.209 27.8873 20.9998 27.8873H11.9998C11.3482 27.8873 10.733 28.0431 10.1895 28.3195L17.7633 36Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 9.12676C1.79086 9.12676 0 10.9176 0 13.1268V17.9864L8.73479 26.8442C10.7153 26.6049 12.25 24.9183 12.25 22.8732V13.1268C12.25 10.9176 10.4591 9.12676 8.25 9.12676H4Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: Number,
    default: 33,
  },
  height: {
    type: Number,
    default: 36,
  },
  color: {
    type: String,
    default: "#3DAB81",
  },
});
</script>

<style scoped>
.logo-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: v-bind(color);
}
</style>
